import {
    Menu,
    MenuButton,
    Text,
    Button,
    MenuList,
    VStack,
    HStack,
    useDisclosure,
    Image,
    Flex,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Input,
    Box,
} from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons';
import React, { useRef } from 'react'
import { IoSearchOutline } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
import { useCollections } from '../../providers/CollectionsProvider';
import { useCategories } from '../../providers/CategoriesProvider';
import { useCarts } from '../../providers/CartProvider';

export default function NavLinks() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { logged, logout } = useAuth()
    const { isOpen: isProductsOpen, onOpen: onProductsOpen, onClose: onProductsClose } = useDisclosure();

    const { loading: collectionsLoading, collectionsForHomePage } = useCollections();
    const { loading: categoriesLoading, categories, accessories } = useCategories();

    const { carts } = useCarts();

    const navigate = useNavigate();

    const searchRef = useRef(null);

    if (collectionsLoading || categoriesLoading) return null;

    return (
        <HStack
            w='100%'
            color='#1c1c1c'
            h='100%'
            justifyContent='space-between'
        >

            <Box
                onClick={onOpen}
                _hover={
                    { cursor: 'pointer' }
                }
            >
                <IoSearchOutline color='#1c1c1c' size={25} />
            </Box>

            <Button
                as={Link}
                to='/'
                fontSize={['sm', 'md', 'md', 'xl']}
                _hover={
                    { bg: 'none' }
                }
                h={'100%'}
                fontWeight={400}
                variant='ghost'
                borderRadius='lg'
            >
                Home
            </Button>

            <Button
                as={Link}
                to='/about'
                fontSize={['sm', 'md', 'md', 'xl']}
                _hover={
                    { bg: 'none' }
                }
                h={'100%'}
                fontWeight={400}
                variant='ghost'
                borderRadius='lg'
            >
                About Us
            </Button>

            <Menu isOpen={isProductsOpen} matchWidth={true}>
                {({ isOpen }) => (
                    <>
                        <MenuButton
                            isActive={isOpen}
                            as={Button}
                            bg='primary'
                            borderRadius='lg'
                            onMouseEnter={onProductsOpen}
                            onMouseLeave={onProductsClose}
                            rightIcon={null}
                            fontSize={['sm', 'md', 'md', 'xl']}
                            h={'80px'}
                            minW='100px'
                            fontWeight={400}
                            _active={{
                                bg: 'none'
                            }}
                        >
                            Shop
                        </MenuButton>

                        <MenuList
                            w='50vw'
                            mx={'-20vw'}
                            mt='-3'
                            onMouseEnter={onProductsOpen}
                            onMouseLeave={onProductsClose}
                            p='0'
                            //  bg='white'
                            bg='#054E47'
                            border={'none'}
                        >
                            <HStack p='10' alignItems='start' w={'100%'} justifyContent={'center'} h='100%'>

                                <VStack alignItems='start' justifyContent='space-between' h='100%' mx={10} gap={6} my={2}>
                                    <Text fontSize='2xl' className='custom' color={'white'}>Categories</Text>
                                    {categories.map((cat, index) => {
                                        return (
                                            <Text
                                                key={index}
                                                as={Link}
                                                to={`/categories/${cat.slug}`}
                                                fontSize='md'
                                                className='custom'
                                                color={'white'}
                                                onClick={onProductsClose}
                                            >
                                                {cat.name}
                                            </Text>
                                        )
                                    })}
                                </VStack>

                                <VStack alignItems='start' justifyContent='space-between' h='100%' mx={10} gap={6} my={2}>
                                    <Text fontSize='2xl' className='custom' color={'white'}>Collections</Text>
                                    {collectionsForHomePage.map((coll, index) => {
                                        return (
                                            <Text key={index} as={Link} to={`/collections/${coll.id}`} fontSize='md' className='custom' color={'white'}>{coll.name}</Text>
                                        )
                                    })}
                                </VStack>

                                <VStack alignItems='start' justifyContent='space-between' h='100%' mx={10} gap={6} my={2}>
                                    <Text fontSize='2xl' className='custom' color={'white'}>Accesories</Text>
                                    {accessories.map((acc, index) => {
                                        return (
                                            <Text key={index} as={Link} to={`/categories/${acc.slug}`} fontSize='md' className='custom' color={'white'}>{acc.name}</Text>
                                        )
                                    })}
                                </VStack>

                            </HStack>
                        </MenuList>
                    </>
                )}
            </Menu>

            <Box
                width='200px'
                as={Link}
                to='/'
                zIndex={1}
                h='60px'
            >
                <img
                    src={'/logo-dark.png'}
                    alt='Logo'
                    height={'80px'}
                    weight={'100%'}
                />
            </Box>

            <Button
                as={Link}
                to='/contact'
                fontSize={['sm', 'md', 'md', 'xl']}
                _hover={
                    { bg: 'none' }
                }
                h={'100%'}
                fontWeight={400}
                variant='ghost'
                borderRadius='lg'
            >
                Contact Us
            </Button>

            <Button
                as={Link}
                to='/wishlist'
                fontSize={['sm', 'md', 'md', 'xl']}
                _hover={
                    { bg: 'none' }
                }
                h={'100%'}
                fontWeight={400}
                variant='ghost'
                borderRadius='lg'
            >
                Wishlist
            </Button>

            {
                logged ? <Menu>
                    <MenuButton
                        bg='none'
                        color='#1c1c1c'
                        fontSize={['sm', 'md', 'md', 'xl']}
                        _hover={{
                            bg: 'none',
                            // color: 'white'
                        }}
                        _active={{
                            bg: 'none'
                        }}
                        as={Button}
                        rightIcon={<ChevronDownIcon />}>
                        My Account
                    </MenuButton>
                    <MenuList
                        gap={5}
                        maxW={'10vw'}
                        bg='#054E47'
                        border={'none'}
                        mt={2}
                    >
                        <VStack
                            w={'100%'}
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            pl={2}
                        >
                            <Button
                                pl={7}
                                _hover={{
                                    bg: 'none',
                                    color: 'white'
                                }}
                                bg='none'
                                color={'white'}
                                fontSize={['sm', 'md', 'md', 'lg']}
                                my={1}
                                as={Link}
                                to='/my-profile'
                            >
                                My Profile
                            </Button>
                            <Button
                                _hover={{
                                    bg: 'none',
                                    color: 'white'
                                }}
                                bg='none'
                                color={'white'}
                                pl={7}
                                fontSize={['sm', 'md', 'md', 'lg']}
                                my={1}
                                as={Link}
                                to='/addresses'
                            >
                                Addresses
                            </Button>
                            <Button
                                _hover={{
                                    bg: 'none',
                                    color: 'white'
                                }}
                                bg='none'
                                color={'white'}
                                pl={7}
                                fontSize={['sm', 'md', 'md', 'lg']}
                                my={1}
                                as={Link}
                                to='/wishlist'
                            >
                                Wishlist
                            </Button>
                            <Button
                                as={Link}
                                _hover={{
                                    bg: 'none',
                                    color: 'white'
                                }}
                                bg='none'
                                color={'white'}
                                pl={7}
                                fontSize={['sm', 'md', 'md', 'lg']}
                                my={1}
                                to='/orders'
                            >
                                Orders
                            </Button>
                            <Button
                                _hover={{
                                    bg: 'none',
                                    color: 'white'
                                }}
                                bg='none'
                                color={'white'}
                                pl={7}
                                fontSize={['sm', 'md', 'md', 'lg']}
                                my={1}
                                onClick={logout}
                            >
                                Logout
                            </Button>
                        </VStack>
                    </MenuList>
                </Menu>
                    :
                    <Link to={`/login`}>
                        <Button
                            fontSize={['sm', 'md', 'md', 'xl']}
                            // color='#FFFFFF'
                            h={'100%'}
                            fontWeight={400}
                            variant='ghost'
                            borderRadius='lg'
                            _hover={
                                { bg: 'none' }
                            }
                        >
                            Sign in
                        </Button>
                    </Link>
            }

            <HStack
                as={Link}
                to={'/cart'}
            >
                <Image
                    src={'/cart.png'}
                    alt=''
                    h={'40px'}
                />
                <Flex
                    position='absolute'
                    top='15px'
                    right='14px'
                    borderRadius={'50%'}
                    // bg={'#ECE7E3'}
                    bg={'primary.800'}
                    color={'#fefefe'}
                    w={'20px'}
                    h={'20px'}
                    justifyContent={'center'}
                    alignItems='center'
                >
                    {carts.length}
                </Flex>

            </HStack>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Search for a product</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody mb={2}>
                        <VStack w='100%' alignItems='start'>
                            <Input
                                ref={searchRef}
                                placeholder="search here..."
                                border='1px solid grey'
                                _focusVisible={
                                    {
                                        border: '1px solid grey'
                                    }
                                }
                            />
                            <Button onClick={() => {
                                onClose();
                                navigate(`/products-search`, { state: { search: searchRef.current.value } });
                            }}>Search</Button>
                        </VStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </HStack>
    )
} 